function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.035 58.252C27.67 70.74 61.986 49.6 62 30.403c.014-19.196-34.088-35.301-48.928-25.387-14.84 9.915-14.673 40.749-.037 53.236z",
  fill: "#1FA956"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33 40l8-8m0 0l-8-8m8 8H22",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgProgramSliderRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjAzNDYgNTguMjUyMkMyNy42NzA3IDcwLjczOTggNjEuOTg2MiA0OS41OTk2IDYyIDMwLjQwMzNDNjIuMDEzOCAxMS4yMDcxIDI3LjkxMTcgLTQuODk4NSAxMy4wNzIyIDUuMDE2MDVDLTEuNzY3MzEgMTQuOTMwNiAtMS42MDE0NyA0NS43NjQ3IDEzLjAzNDYgNTguMjUyMloiIGZpbGw9IiMxRkE5NTYiLz4KPHBhdGggZD0iTTMzIDQwTDQxIDMyTTQxIDMyTDMzIDI0TTQxIDMySDIyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgProgramSliderRightArrow as ReactComponent };